import { ChevronRightIcon } from '@heroicons/react/20/solid'

const ChevronRotate = ({ open }: { open: boolean }) => {
  return (
    <div className="w-5 h-5">
      <ChevronRightIcon
        className={`w-5 h-5 transition-transform duration-300 motion-reduce:transition-none ${
          open ? 'ltr:rotate-90 rtl:rotate-90' : 'ltr:rotate-0 rtl:rotate-180'
        }`}
      />
    </div>
  )
}

export default ChevronRotate
